import * as yup from 'yup';

import { TimestampType } from '@britishcouncil/common-core';

export const schema = yup.object({
  sessionDate: yup.mixed<TimestampType>().required('Required'),
  venueId: yup.number().required(),
  testTakerAdmissionTimeMinutes: yup.number().min(0).max(99).nullable().default(null),
});

export type CreateSpeakingSessionFormValues = yup.InferType<typeof schema>;
